module.exports = __webpack_public_path__ + "static/osez-devenir-speaker-db12c288f327197724ca7449ae5d7dde.png";